@if (broadcastMessage && active$ | async) {
<div @slideOut class="p-2 gap-1 flex justify-between items-center frame-broadcast-message bg-yellow-300">
  <div class="flex items-center gap-3">
    <mat-icon class="hidden md:block">campaign</mat-icon>
    <div [innerHTML]="broadcastMessage.message"></div>
  </div>
  @if (broadcastMessage.dismissable) {
  <button (click)="onClose()" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
  }
</div>
}
